import {Component, Input} from '@angular/core';
import {ProfileField} from "../../services/profile-requirements.service";
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-profile-fields',
    templateUrl: './profile-fields.component.html',
    styleUrls: ['./profile-fields.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, MatTooltipModule]
})
export class ProfileFieldsComponent {

  @Input()
  fields?: ProfileField[] ;

  getFieldName(field: ProfileField): string {
    switch (field) {
      case "BIO":
        return "bio";
      case "SELFIE":
        return "selfie" ;
      case "AVATAR":
        return "avatar" ;
    }
  }

  getFieldDescription(field: ProfileField): string {
    switch (field) {
      case "BIO":
        return "a sentence or so describing yourself, to break the ice";
      case "SELFIE":
        return "a recent photo of yourself, so people can recognize you" ;
      case "AVATAR":
        return "an artistic portrait that people can (hopefully) recognize you from" ;
    }
  }

}
